export function drawFloatingSand(ctx, width, height, time) {
  ctx.save();
  
  for (let i = 0; i < 30; i++) {
    const x = (Math.sin(time * 0.25 + i) * width * 0.45) + width * 0.5;
    const y = (Math.cos(time * 0.18 + i * 0.9) * height * 0.35) + height * 0.45;
    const size = 1.2 + Math.sin(time * 1.8 + i) * 0.6;
    
    ctx.fillStyle = `hsla(38, 75%, 58%, ${0.45 + Math.sin(time + i) * 0.25})`;
    ctx.beginPath();
    ctx.arc(x, y, size, 0, Math.PI * 2);
    ctx.fill();
  }
  
  ctx.restore();
}

export function drawHeatShimmer(ctx, width, height, time) {
  ctx.save();
  
  // Enhanced heat shimmer waves
  for (let i = 0; i < 4; i++) {
    const shimmerY = height * 0.55 + i * 18;
    const alpha = 0.12 + Math.sin(time * 1.8 + i) * 0.06;
    
    ctx.strokeStyle = `hsla(42, 65%, 68%, ${alpha})`;
    ctx.lineWidth = 1.5;
    ctx.beginPath();
    
    for (let x = 0; x <= width; x += 3) {
      const y = shimmerY + Math.sin(x * 0.018 + time * 2.8 + i) * 9 + Math.sin(x * 0.035 + time * 1.5) * 4;
      if (x === 0) {
        ctx.moveTo(x, y);
      } else {
        ctx.lineTo(x, y);
      }
    }
    ctx.stroke();
  }
  
  ctx.restore();
}